module.exports = __webpack_public_path__ + "static/img/personalMailTip2.7b322fb2.png";